import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import RepairsContent from "../../components/Repairs/RepairsContent";
import {
  getDepartmentMasterList,
  getVesselMasterList,
} from "../../redux/actions/mastersAction";
import { useDispatch, useSelector } from "react-redux";

const Repairs = () => {
  const dispatch = useDispatch();

  const CompanyID = localStorage.getItem("companyID");

  useEffect(() => {
    dispatch(
      getDepartmentMasterList({
        companyId: CompanyID,
      })
    );
    dispatch(
      getVesselMasterList({
        active: "true",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
  }, []);

  return (
    <>
      <Sidebar activeTab="Repairs" title="Repairs">
        <Box className="globalContainer_For_Content">
          <RepairsContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default Repairs;
